export default {
  WEBRTC_CONNECTION_TIMEOUT_WARNING: "The call will be closed automatically if the participant cannot connect.",
  WEBRTC_DISCONNECT_WARNING:
    "The other participant has disconnected. Trying to reconnect, The call will be closed automatically if the participant cannot reconnect.",
  WEBRTC_CALL_HOLD_MESSAGE: "The customer representative has put the call on hold. The call will be resumed as soon as possible.",

  GettingCallDetails: "Getting Call Details..",
  PhotoIsBeingCaptured: "Photo is being captured.",

  UserMediaError: "User Media Error",
  UserMediaNotAllowedError: "Camera or Microphone access denied by the user.",
  UserMediaNotFoundError: "No camera or microphone device found.",
  UserMediaNotReadableError: "Camera is already in use by another application.",
  UserMediaOverconstrainedError: "The specified constraints cannot be met by any available camera or microphone.",
  UserMediaSecurityError: "Camera or Microphone access is not allowed in insecure contexts.",
  UserMediaTypeError: "The constraints object provided by ECV are malformed or contains invalid values.",
  UserMediaUnknownError: "Unknown Camera or Microphone error",
  Ok: "Ok",
  TheCallHasEnded: "The call has ended!",

  StatusCheck: "Status Check",
  Start: "Start",
  Started: "Started",
  Copyright: "Copyright",
  AllRightsReserved: "All Rights Reserved.",
  ClientStatus: "Client Status",
  Microphone: "Microphone",
  Camera: "Camera",
  TURNConnectivity: "TURN Connectivity",
  ECVServicesStatus: "ECV Services Status",
  QueueSocketConnectivity: "Queue Socket Connectivity",
  SignalingSocketConnectivity: "Signaling Socket Connectivity",
  RecordingFailed:
    "A technical error occurred during video recording. Please do not continue the call. Direct the customer to start a new call. Inform your team leader about the issue.",
  RecordingFailedReason: "Message: {reason}",
};
